import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loadType: -1,
  },
  types: [],
  meta: {},
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.EMC_DIGI_TYPES_REQUESTED:
      return {
        ...state,
        status: {
          loadType: 0,
        },
      };
    case ACTION_TYPES.EMC_DIGI_TYPES_SUCCEED:
      return {
        ...state,
        status: {
          loadType: 1,
        },
        types: payload.data,
        meta: payload.meta,
      };
    case ACTION_TYPES.EMC_DIGI_TYPES_FAILED:
      return {
        ...state,
        status: {
          loadType: 2,
        },
        error,
      };
    default:
      return state;
  }
}
